module.exports = __webpack_public_path__ + "static/img/yg_btn2.92151ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/yg_btn2.png
// module id = M4+X
// module chunks = 7